import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import type { MouseEvent } from 'react';

interface Props {
    lat: number;
    lng: number;
    label: string;
    onClick?: (e: MouseEvent<HTMLDivElement>) => void;
}

const CustomClusterMarker = ({ label, onClick }: Props) => {
    return (
        <Box
            sx={{
                position: 'relative',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                px: 2.5,
                py: 1,
                borderRadius: '50%',
                backgroundColor: (theme: any) => theme.palette.error.main,
                ':hover': { backgroundColor: (theme: any) => theme.palette.error.dark, cursor: 'pointer' },
            }}
            onClick={(e) => {
                e.stopPropagation();
                onClick?.(e);
            }}
        >
            <Typography sx={{ userSelect: 'none' }} fontWeight={700} color={'white'}>
                {label}
            </Typography>
        </Box>
    );
};

export default CustomClusterMarker;
